import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _589ba355 = () => interopDefault(import('../pages/actions/index.vue' /* webpackChunkName: "pages/actions/index" */))
const _df62e26c = () => interopDefault(import('../pages/brands/index.vue' /* webpackChunkName: "pages/brands/index" */))
const _78f1b044 = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _694d8771 = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _53069b6d = () => interopDefault(import('../pages/collections/index.vue' /* webpackChunkName: "pages/collections/index" */))
const _91ef9256 = () => interopDefault(import('../pages/company/index.vue' /* webpackChunkName: "pages/company/index" */))
const _33f0d53d = () => interopDefault(import('../pages/compare/index.vue' /* webpackChunkName: "pages/compare/index" */))
const _4f6f6b49 = () => interopDefault(import('../pages/delete-account/index.vue' /* webpackChunkName: "pages/delete-account/index" */))
const _6b9ae6e8 = () => interopDefault(import('../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _652b86bf = () => interopDefault(import('../pages/help/index.vue' /* webpackChunkName: "pages/help/index" */))
const _32d41028 = () => interopDefault(import('../pages/info/index.vue' /* webpackChunkName: "pages/info/index" */))
const _80a823fe = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _b8552df0 = () => interopDefault(import('../pages/logout/index.vue' /* webpackChunkName: "pages/logout/index" */))
const _78a3185e = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _47caa8b4 = () => interopDefault(import('../pages/order/index.vue' /* webpackChunkName: "pages/order/index" */))
const _0f99e17e = () => interopDefault(import('../pages/personal/index.vue' /* webpackChunkName: "pages/personal/index" */))
const _20aa20bc = () => interopDefault(import('../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _5a93e530 = () => interopDefault(import('../pages/stores/index.vue' /* webpackChunkName: "pages/stores/index" */))
const _bcbf36da = () => interopDefault(import('../pages/video/index.vue' /* webpackChunkName: "pages/video/index" */))
const _0a68d2da = () => interopDefault(import('../pages/company/about/index.vue' /* webpackChunkName: "pages/company/about/index" */))
const _5f11efa3 = () => interopDefault(import('../pages/company/contacts/index.vue' /* webpackChunkName: "pages/company/contacts/index" */))
const _0938aaea = () => interopDefault(import('../pages/company/requisites/index.vue' /* webpackChunkName: "pages/company/requisites/index" */))
const _0e9b1e02 = () => interopDefault(import('../pages/order/pay/index.vue' /* webpackChunkName: "pages/order/pay/index" */))
const _3c37438c = () => interopDefault(import('../pages/order/pay-error/index.vue' /* webpackChunkName: "pages/order/pay-error/index" */))
const _7293f240 = () => interopDefault(import('../pages/order/pay-ok/index.vue' /* webpackChunkName: "pages/order/pay-ok/index" */))
const _d04e7208 = () => interopDefault(import('../pages/personal/bonuses/index.vue' /* webpackChunkName: "pages/personal/bonuses/index" */))
const _3fa0dba8 = () => interopDefault(import('../pages/personal/orders/index.vue' /* webpackChunkName: "pages/personal/orders/index" */))
const _f81ec6d0 = () => interopDefault(import('../pages/personal/profile/index.vue' /* webpackChunkName: "pages/personal/profile/index" */))
const _3f803858 = () => interopDefault(import('../pages/personal/orders/__id/index.vue' /* webpackChunkName: "pages/personal/orders/__id/index" */))
const _13ad244b = () => interopDefault(import('../pages/actions/__id/index.vue' /* webpackChunkName: "pages/actions/__id/index" */))
const _b487cc14 = () => interopDefault(import('../pages/brands/__id/index.vue' /* webpackChunkName: "pages/brands/__id/index" */))
const _c5609e02 = () => interopDefault(import('../pages/catalog/__slug/index.vue' /* webpackChunkName: "pages/catalog/__slug/index" */))
const _0d192cfa = () => interopDefault(import('../pages/collections/__slug/index.vue' /* webpackChunkName: "pages/collections/__slug/index" */))
const _1dbf041e = () => interopDefault(import('../pages/help/__slug/index.vue' /* webpackChunkName: "pages/help/__slug/index" */))
const _e84c5fb8 = () => interopDefault(import('../pages/info/__slug/index.vue' /* webpackChunkName: "pages/info/__slug/index" */))
const _f1157d62 = () => interopDefault(import('../pages/news/__id/index.vue' /* webpackChunkName: "pages/news/__id/index" */))
const _7c9affc4 = () => interopDefault(import('../pages/products/__id/index.vue' /* webpackChunkName: "pages/products/__id/index" */))
const _252a5960 = () => interopDefault(import('../pages/stores/__id/index.vue' /* webpackChunkName: "pages/stores/__id/index" */))
const _79c2bae7 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/actions",
    component: _589ba355,
    name: "actions"
  }, {
    path: "/brands",
    component: _df62e26c,
    name: "brands"
  }, {
    path: "/cart",
    component: _78f1b044,
    name: "cart"
  }, {
    path: "/catalog",
    component: _694d8771,
    name: "catalog"
  }, {
    path: "/collections",
    component: _53069b6d,
    name: "collections"
  }, {
    path: "/company",
    component: _91ef9256,
    name: "company"
  }, {
    path: "/compare",
    component: _33f0d53d,
    name: "compare"
  }, {
    path: "/delete-account",
    component: _4f6f6b49,
    name: "delete-account"
  }, {
    path: "/favourites",
    component: _6b9ae6e8,
    name: "favourites"
  }, {
    path: "/help",
    component: _652b86bf,
    name: "help"
  }, {
    path: "/info",
    component: _32d41028,
    name: "info"
  }, {
    path: "/login",
    component: _80a823fe,
    name: "login"
  }, {
    path: "/logout",
    component: _b8552df0,
    name: "logout"
  }, {
    path: "/news",
    component: _78a3185e,
    name: "news"
  }, {
    path: "/order",
    component: _47caa8b4,
    name: "order"
  }, {
    path: "/personal",
    component: _0f99e17e,
    name: "personal"
  }, {
    path: "/products",
    component: _20aa20bc,
    name: "products"
  }, {
    path: "/stores",
    component: _5a93e530,
    name: "stores"
  }, {
    path: "/video",
    component: _bcbf36da,
    name: "video"
  }, {
    path: "/company/about",
    component: _0a68d2da,
    name: "company-about"
  }, {
    path: "/company/contacts",
    component: _5f11efa3,
    name: "company-contacts"
  }, {
    path: "/company/requisites",
    component: _0938aaea,
    name: "company-requisites"
  }, {
    path: "/order/pay",
    component: _0e9b1e02,
    name: "order-pay"
  }, {
    path: "/order/pay-error",
    component: _3c37438c,
    name: "order-pay-error"
  }, {
    path: "/order/pay-ok",
    component: _7293f240,
    name: "order-pay-ok"
  }, {
    path: "/personal/bonuses",
    component: _d04e7208,
    name: "personal-bonuses"
  }, {
    path: "/personal/orders",
    component: _3fa0dba8,
    name: "personal-orders"
  }, {
    path: "/personal/profile",
    component: _f81ec6d0,
    name: "personal-profile"
  }, {
    path: "/personal/orders/:_id",
    component: _3f803858,
    name: "personal-orders-_id"
  }, {
    path: "/actions/:_id",
    component: _13ad244b,
    name: "actions-_id"
  }, {
    path: "/brands/:_id",
    component: _b487cc14,
    name: "brands-_id"
  }, {
    path: "/catalog/:_slug",
    component: _c5609e02,
    name: "catalog-_slug"
  }, {
    path: "/collections/:_slug",
    component: _0d192cfa,
    name: "collections-_slug"
  }, {
    path: "/help/:_slug",
    component: _1dbf041e,
    name: "help-_slug"
  }, {
    path: "/info/:_slug",
    component: _e84c5fb8,
    name: "info-_slug"
  }, {
    path: "/news/:_id",
    component: _f1157d62,
    name: "news-_id"
  }, {
    path: "/products/:_id",
    component: _7c9affc4,
    name: "products-_id"
  }, {
    path: "/stores/:_id",
    component: _252a5960,
    name: "stores-_id"
  }, {
    path: "/",
    component: _79c2bae7,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
